var map = {
	"./videos.primary.2018.json": [
		"nHRz",
		5
	],
	"./videos.primary.2019.json": [
		"h5B3",
		4
	],
	"./videos.primary.2020.json": [
		"Ygue",
		3
	],
	"./videos.secondary.2018.json": [
		"e7HY",
		2
	],
	"./videos.secondary.2019.json": [
		"gfyV",
		1
	],
	"./videos.secondary.2020.json": [
		"9GX9",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "3jqu";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/data lazy ^\.\/videos\..*\.json$
// module id = 3jqu
// module chunks = 7